import { useSelector } from 'react-redux';

/**
 * Reads the backend-configurable on/off toggle for a single GTM/GA4 event
 * (state.GoogleTagManagerReducer.config.events[eventName]) — the same
 * switch the legacy GoogleTagManagerContainer honors, without pulling in
 * its eventList/dedupe machinery.
 */
export default function useGtmEventEnabled(eventName) {
    return useSelector((state) => Boolean(state.GoogleTagManagerReducer?.config?.events?.[eventName]));
}
